import { ClassName } from '@busybusy/webapp-react-ui';
import { CertificationForm, ICertificationFormData } from '../CertificationForm/CertificationForm';
import classNames from 'classnames';
import { HeaderDialog } from 'components';
import { t } from 'i18next';

export interface ICreateCertificationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (data: ICertificationFormData) => void;
  className?: ClassName;
}

export const CreateCertificationDialog = (props: ICreateCertificationDialogProps) => {
  const { isOpen, onClose, onCreate, className } = props;

  const classes = classNames('create-certification-dialog', className);

  return (
    <HeaderDialog isOpen={isOpen} onClose={onClose} title={t('New Certification')} divider={false} className={classes}>
      <CertificationForm onFormSubmit={onCreate} />
    </HeaderDialog>
  );
};
